<template>
  <v-app>
    <!-- Nav bar -->
    <v-app-bar app flat dark color="transparent" class="app-bar-glass" v-if="isAuthenticated">
      <div class="d-flex align-center">
        <div class="logo-mark mr-2">L</div>
        <span class="text-h6 font-weight-bold white--text">Labelbase</span>
      </div>
      <v-spacer />
      <div class="nav-pills d-flex align-center">
        <v-btn
          text
          to="/"
          exact
          class="nav-btn mx-1"
          active-class="nav-btn-active"
        >
          <v-icon left small>mdi-label-multiple</v-icon>
          Generate
        </v-btn>
        <v-btn
          text
          to="/history"
          class="nav-btn mx-1"
          active-class="nav-btn-active"
        >
          <v-icon left small>mdi-history</v-icon>
          History
        </v-btn>
        <v-btn
          text
          to="/products"
          class="nav-btn mx-1"
          active-class="nav-btn-active"
        >
          <v-icon left small>mdi-package-variant-closed</v-icon>
          Products
        </v-btn>
      </div>
      <v-spacer />
      <v-chip small outlined dark class="mr-3">
        <v-icon left small>mdi-account</v-icon>
        {{ username }}
      </v-chip>
      <v-btn icon small @click="logout">
        <v-icon small>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="main-bg-dark">
      <v-container fluid class="pa-6 pa-md-8">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </v-main>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" top rounded="pill">
      {{ snackbar.text }}
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: function () {
    return {
      snackbar: { show: false, text: '', color: 'success' },
    };
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated;
    },
    username: function () {
      return this.$store.state.username || 'admin';
    },
  },
  created: function () {
    if (this.isAuthenticated) {
      this.$store.dispatch('fetchProducts');
    }
  },
  methods: {
    logout: function () {
      this.$store.commit('logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style>
/* Global */
* { transition: background-color 0.2s ease; }
html { overflow-y: auto !important; }

.main-bg-dark {
  background: linear-gradient(135deg, #0F0C29 0%, #1A1A2E 50%, #16213E 100%) !important;
  min-height: 100vh;
}
/* Glass nav */
.app-bar-glass {
  backdrop-filter: blur(16px) !important;
  background: rgba(22, 33, 62, 0.7) !important;
  border-bottom: 1px solid rgba(108, 99, 255, 0.15) !important;
}

/* Logo */
.logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #6C63FF 0%, #A78BFA 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 16px;
  color: white;
}

/* Nav pills */
.nav-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
  opacity: 0.7;
}
.nav-btn-active {
  background: rgba(108, 99, 255, 0.2) !important;
  opacity: 1 !important;
}

/* Card style override */
.v-card {
  border-radius: 12px !important;
}
.theme--dark .v-card {
  background: rgba(22, 33, 62, 0.6) !important;
  border: 1px solid rgba(108, 99, 255, 0.1) !important;
}
/* Data table */
.theme--dark .v-data-table {
  background: transparent !important;
}
.theme--dark .v-data-table .v-data-table-header th {
  color: rgba(255,255,255,0.5) !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

/* Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.15s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* Chip style */
.v-chip { font-weight: 500 !important; }

/* Dialog */
.v-dialog .v-card {
  border: 1px solid rgba(108, 99, 255, 0.2) !important;
}
</style>
